import { graphqlClient } from "../../../client";
import queryDocument from "./createAuthenticationSetupQuery.graphql";
import type {
  PayerAuthenticationSetupResultType,
  Query,
  QueryCreateAuthenticationSetupArgs,
} from "@/core/api/graphql/types";

export async function createAuthenticationSetup(
  token: string,
  dataAreaId: string,
  paymentTokenId?: string,
  customerId?: string,
): Promise<PayerAuthenticationSetupResultType> {
  const { data } = await graphqlClient.query<
    Required<Pick<Query, "createAuthenticationSetup">>,
    QueryCreateAuthenticationSetupArgs
  >({
    query: queryDocument,
    variables: {
      token,
      dataAreaId,
      paymentTokenId,
      customerId: customerId ?? "",
    },
  });

  return data.createAuthenticationSetup;
}
